import basePath from "base_path";

import ActionTypes, {MattersActionTypes} from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {MatterId} from "common/types/matter";

export type MatterRenameAction = {
  type: MattersActionTypes["MATTER_RENAME"]["SUCCESS"];
  payload: {id: MatterId; name: string};
};

export default function renameMatter(requestor) {
  return createReduxPromiseAction(
    ActionTypes.MATTER_RENAME,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      matterId: MatterId,
      name: string,
    ) => {
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/project/${projectId}/matter/${matterId}`,
          {name},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
